import { Box, Typography } from '@mui/material';
import GaugeChart from 'react-gauge-chart';

const MAX_SCORE = 1000;

const RANGES = [
  { label: 'Baixo (0-300)', color: '#ef4444' },
  { label: 'Médio (301-700)', color: '#f59e0b' },
  { label: 'Alto (701-1000)', color: '#22c55e' },
];

const getScoreColor = (score) => {
  if (score <= 300) return '#ef4444';
  if (score <= 700) return '#f59e0b';
  return '#22c55e';
};

const ScoreGauge = ({
  score = 0,
  riskPercentage = 0,
  riskLabel = 'Probabilidade de inadimplência',
}) => {
  const scoreColor = getScoreColor(score);
  const percent = Math.min(Math.max(score, 0), MAX_SCORE) / MAX_SCORE;

  return (
    <Box>
      <Box sx={{ width: '100%' }}>
        <GaugeChart
          id={`score-gauge-${score}`}
          nrOfLevels={20}
          percent={percent}
          arcWidth={0.25}
          arcPadding={0.02}
          cornerRadius={4}
          colors={['#ef4444', '#f59e0b', '#22c55e']}
          needleColor="#374151"
          needleBaseColor="#374151"
          hideText
          animate={false}
          style={{ width: '100%' }}
        />
      </Box>

      <Box textAlign="center">
        <Typography
          component="span"
          sx={{ fontSize: 36, fontWeight: 800, color: '#1f2937', lineHeight: 1 }}
        >
          {Math.floor(score)}
        </Typography>
        <Typography
          component="span"
          sx={{ fontSize: 15, fontWeight: 400, color: '#6b7280', ml: 1 }}
        >
          de {MAX_SCORE}
        </Typography>
      </Box>

      <Typography sx={{ fontSize: 14, color: '#4b5563', textAlign: 'center', mt: 1.5 }}>
        {riskLabel}:{' '}
        <Typography component="span" fontWeight={700} fontSize={14} color={scoreColor}>
          {riskPercentage.toFixed(2)}%
        </Typography>
      </Typography>

      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 2, flexWrap: 'wrap' }}>
        {RANGES.map((range) => (
          <Box key={range.label} display="flex" alignItems="center" gap={0.5}>
            <Box
              sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: range.color, flexShrink: 0 }}
            />
            <Typography fontSize={12} color="#6b7280">
              {range.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ScoreGauge;
